import { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useCurrentUserContext } from 'utils/User';

import ROUTE_NAMES from 'setup/Routing/routeNames';

type Props = {
  children: React.ReactNode;
};

export default function ManagerRoute({ children }: Props) {
  const { isOemManager, isSuperUser, managedSentinelTeams } =
    useCurrentUserContext();
  const location = useLocation();

  const amountOfManagedTeams =
    managedSentinelTeams?.length ?? /* istanbul ignore next -- @preserve */ 0;

  const shouldRedirect = useMemo(() => {
    return !(isSuperUser || isOemManager || amountOfManagedTeams > 1);
  }, [isOemManager, isSuperUser, amountOfManagedTeams]);

  if (shouldRedirect) {
    return (
      <Navigate
        to={ROUTE_NAMES.access_denied}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
}

ManagerRoute.propTypes = {
  children: PropTypes.node,
};

ManagerRoute.defaultProps = {
  children: null,
};
